/**
 * Zugriffsverwaltung eines Projekts: Bereichskatalog, Berechtigte, Freigaben.
 */
import { api } from "./client";
import {
  BereichKatalog,
  FreigabeAngelegt,
  FreigabeBereich,
  MeineRechteResponse,
  ExterneFreigabe,
  ZugriffAnlegen,
  ZugriffUebersicht,
} from "../../types/zugriff";

export const zugriffApi = {
  /** Der Bereichskatalog – einzige Quelle der Gliederung, kommt vom Backend. */
  async getBereichOptions(): Promise<BereichKatalog> {
    return api.get("/zugriff/bereich-options");
  },

  /** Die eigene Sicht auf ein Projekt: intern/extern und die effektiven Bereichsrechte. */
  async getMeineRechte(projectId: string): Promise<MeineRechteResponse> {
    return api.get(`/projects/${projectId}/meine-rechte`);
  },

  async getZugriff(projectId: string): Promise<ZugriffUebersicht> {
    return api.get(`/projects/${projectId}/zugriff`);
  },

  async freigeben(
    projectId: string,
    daten: ZugriffAnlegen,
  ): Promise<FreigabeAngelegt> {
    return api.post(`/projects/${projectId}/zugriff`, daten);
  },

  async aendern(
    projectId: string,
    subjekt: string,
    bereiche: FreigabeBereich[],
  ): Promise<ExterneFreigabe> {
    return api.put(
      `/projects/${projectId}/zugriff/${encodeURIComponent(subjekt)}`,
      {
        bereiche,
      },
    );
  },

  async entziehen(projectId: string, subjekt: string): Promise<void> {
    return api.delete(
      `/projects/${projectId}/zugriff/${encodeURIComponent(subjekt)}`,
    );
  },
};
